import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/base.css';
import { deleteRequest, downPostRequest, getRequest, postRequest, putRequest } from '@/config/request'

import router from './router'
import store from './store'

//需要挂载到Vue原型上
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.downPostRequest = downPostRequest;

Vue.use(ElementUI);

import plugins from './plugins' // plugins
Vue.use(plugins)

Vue.config.productionTip = false

import translate from 'i18n-jsautotranslate'
translate.setUseVersion2() //设置使用v2.x 版本
translate.selectLanguageTag.show = false //是否显示切换栏
translate.listener.start() //监控页面动态渲染的文本进行自动翻译
Vue.prototype.$translate = translate

router.beforeEach((to, from, next) => {
  const token = window.sessionStorage.getItem('token');

  // 如果访问的路由不存在，跳转到 404 页面
  if (to.matched.length === 0) {
    return next({ name: '404' }); // 确保你在路由表中定义了 404 页面
  }

  if (!token && to.name !== 'login') {
    return next({ name: 'login' });
  }

  if (token && to.name === 'login') {
    return next({ path: '/dashboard' });
  }

  next();
});


import './assets/font/iconfont.css'

// 上传图片组件
import ImageUpload from '@/components/ImageUpload'
// 文件上传组件
import FileUpload from '@/components/FileUpload'
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
// 富文本组件
import Editor from "@/components/Editor"
// 拖拽穿梭框
import dragTransfer from "@/components/dragTransfer"
// 自定义分段控制器
import SegmentController from "@/components/SegmentController"
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// 全局组件挂载
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)
Vue.component('FileUpload', FileUpload)
Vue.component('Editor', Editor)
Vue.component('dragTransfer', dragTransfer)
Vue.component('SegmentController', SegmentController)
Vue.component(CollapseTransition.name, CollapseTransition)

import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
